import ApiIcon from "@mui/icons-material/Api";
import {PageHeader, Spacer} from "common";
import I18n from "i18n-js";
import OpenapiKeyForm from "./OpenapiKeyForm";
import useOpenapiKeyList from "./useOpenapiKeyList";
import useAccess from "../profile/useAccess";
import {PERMISSIONS} from "../../app/constants";
import DataCard from "../../components/DataCard/DataCard";
import {CardSettings} from "../../components/DataCard/useDataCard";
import {GridActionsCellItem} from "@mui/x-data-grid";
import AutorenewIcon from "@mui/icons-material/Autorenew";

export default function OpenapiKeyList() {
  const {
    renew,
    ...grid
  } = useOpenapiKeyList();
  const access = useAccess();
  const cardSettings: CardSettings = {
    header: {
      titleField: "name"
    }
  };

  return (
    <>
      <PageHeader avatar={<ApiIcon />} title={I18n.t("OpenapiKey.title")} />
      <Spacer h={2} />
      <DataCard
        {...grid}
        headerItems={["search", "refresh"]}
        canCreate={access.hasPermissions(PERMISSIONS.MANAGE_OPENAPIS)}
        canDelete={access.hasPermissions(PERMISSIONS.MANAGE_OPENAPIS)}
        canEdit={access.hasPermissions(PERMISSIONS.MANAGE_OPENAPIS)}
        dialogFullWidth
        renderModalForm={props => <OpenapiKeyForm disabled={!access.hasPermissions(PERMISSIONS.MANAGE_OPENAPIS)} {...props} />}
        cardSettings={cardSettings}
        cardActions={(params: Record<string, any>) => [
          <GridActionsCellItem
            icon={<AutorenewIcon/>}
            label={I18n.t("OpenapiKey.renew")}
            title={I18n.t("OpenapiKey.renew")}
            onClick={() => {
              renew(params.id);
            }}
          />,
        ]}
      />
    </>
  );
}
